import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LOCATION_INITIALIZED } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthenticationService } from "./authentications/authentication.service";

import * as packageJson from './../../package.json';
import { firstValueFrom } from 'rxjs';
import { UmamiService } from "./services/umami.service";

// AoT requires an exported function for factories
export function httpLoaderFactory(http: HttpClient) {
  const { version } = packageJson;

  //return new TranslateHttpLoader(http, '/fspro-translations/dev/');
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?version=${version}`);
}

export function ApplicationInitializerFactory(
  translate: TranslateService,
  injector: Injector,
  authenticationService: AuthenticationService,
  umamiService: UmamiService
) {
  return async () => {
    await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

    const defaultLang = 'en';
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang(defaultLang);
    try {
      await firstValueFrom(translate.use(defaultLang));
    } catch (err) {
      console.log(err);
    }

    // Preserve the back-office session while requesting the impersonation token.
    if (!window.location.pathname.startsWith('/impersonate/')) {
      try {
        await firstValueFrom(authenticationService.refreshToken());
      } catch (error) {
        await authenticationService.signOut();
      }
    }

    umamiService.loadUmamiScript('cd759c77-7b73-4961-8b89-21c74364daab');
  }
}


